export default "__VITE_ASSET__rbWO_kpH__"